<template>
  <div v-if="!loading">
    <div class="container-large p-5">
      <b-row>
        <b-col cols="3" style="overflow: auto">
          <!--<b-button
            class="c2icolor"
            style="width: 100%"
            v-b-toggle.collapse-info
            >Informations</b-button
          >
          <b-collapse id="collapse-info" accordion="base-accordion">
            <b-card>
              <b-row class="ml-2">
                Latitude : {{ map.currentCenter.lat.toFixed(3) }}
              </b-row>
              <b-row class="ml-2">
                Longitude : {{ map.currentCenter.lng.toFixed(3) }}
              </b-row>
              <b-row class="ml-2 mb-2">
                Zoom : {{ map.currentZoom.toFixed(3) }}
              </b-row>
              <b-button
                variant="primary"
                style="width: 100%"
                class="mt-1"
                @click="goToCoordinates(c2iCoordinates, 18)"
                >Centrer sur C2i santé</b-button
              >
            </b-card>
          </b-collapse> -->
          <b-button
            style="width: 100%"
            class="mt-2 c2icolor"
            v-b-toggle.collapse-drawing-options
            >Calques</b-button
          >
          <b-collapse
            visible
            id="collapse-drawing-options"
            accordion="base-accordion"
          >
            <b-card>
              <b-form-group>
                <b-form-checkbox-group>
                  <b-row class="ml-1">
                    <b-form-checkbox v-model="drawPolygon" value="markers"
                      >Marqueurs affichés</b-form-checkbox
                    >
                  </b-row>
                  <b-row class="ml-1">
                    <b-form-checkbox v-model="drawPolygon" value="users"
                      >Chargés de comptes</b-form-checkbox
                    >
                  </b-row>
                  <b-row class="ml-1">
                    <b-form-checkbox v-model="drawPolygon" value="departements"
                      >Départements</b-form-checkbox
                    >
                  </b-row>
                  <b-row class="ml-1">
                    <b-form-checkbox v-model="drawPolygon" value="regions"
                      >Régions</b-form-checkbox
                    >
                  </b-row>
                  <b-row class="ml-1">
                    <b-form-checkbox v-model="drawPolygon" value="regionsSF"
                      >Régions C2i santé</b-form-checkbox
                    >
                  </b-row>
                </b-form-checkbox-group>
              </b-form-group>
            </b-card>
          </b-collapse>
          <b-button
            style="width: 100%"
            class="mt-2 c2icolor"
            v-b-toggle.collapse-clustering-options
            >Option de regroupement</b-button
          >
          <b-collapse
            visible
            id="collapse-clustering-options"
            accordion="base-accordion"
          >
            <b-card>
              <b-form-radio v-model="clustering" value="auto"
                >Automatique</b-form-radio
              >
              <b-form-radio v-model="clustering" value="none"
                >Aucun</b-form-radio
              >
              <b-form-checkbox class="mt-4 mb-4" v-model="showMarkers"
                >Afficher/cacher les marqueurs</b-form-checkbox
              >
            </b-card>
          </b-collapse>
          <b-button
            style="width: 100%"
            class="mt-2 c2icolor"
            v-b-toggle.collapse-coloring-options
            >Zone statistique
          </b-button>
          <b-collapse
            visible
            id="collapse-coloring-options"
            accordion="base-accordion"
          >
            <b-card>
              <b-row no-gutters>
                <b-col>
                  <b-form-group label-align="center" class="mt-2">
                    <b-form-radio v-model="coloring" value="none"
                      >Aucun</b-form-radio
                    >
                    <b-form-radio
                      v-model="coloring"
                      :disabled="!geoJsonMarkersChecked(geoJsonUsers)"
                      value="chargeAffaires"
                      >Par chargé de comptes</b-form-radio
                    >
                    <b-form-radio
                      v-model="coloring"
                      :disabled="!geoJsonMarkersChecked(geoJsonTypes)"
                      value="type"
                      >Par type de client</b-form-radio
                    >
                    <b-form-radio
                      v-model="coloring"
                      :disabled="!geoJsonMarkersChecked(geoJsonTypologies)"
                      value="typology"
                      >Par typologie</b-form-radio
                    >
                    <b-form-radio
                      v-model="coloring"
                      :disabled="!geoJsonMarkersChecked(geoJsonDepartements)"
                      value="departement"
                      >Par département</b-form-radio
                    >
                    <b-form-radio
                      v-model="coloring"
                      :disabled="!geoJsonMarkersChecked(geoJsonRegions)"
                      value="region"
                      >Par régions</b-form-radio
                    >
                    <b-form-radio
                      v-model="coloring"
                      :disabled="!geoJsonMarkersChecked(geoJsonRegionsSF)"
                      value="regionSF"
                      >Par régions C2i santé</b-form-radio
                    >
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card>
          </b-collapse>
          <b-button
            style="width: 100%"
            class="mt-2 c2icolor"
            v-b-toggle.collapse-indicator-options
            >Indicateur</b-button
          >
          <b-collapse
            visible
            id="collapse-indicator-options"
            accordion="base-accordion"
          >
            <b-card>
              <b-row no-gutters>
                <b-col>
                  <b-form-group label-align="center" class="mt-2">
                    <b-row>
                      <b-col cols="8">Indicateurs</b-col>
                      <b-col
                        v-b-tooltip.hover
                        title="L'indicateur sera utilisé comme graduation pour les zones de la carte."
                        cols="2"
                      >
                        <b-icon-question-circle />
                      </b-col>
                      <b-col
                        v-b-tooltip.hover
                        title="L'indicateur sera affiché dans le panneau d'information des zones de la carte."
                        cols="2"
                      >
                        <b-icon-question-circle />
                      </b-col>
                    </b-row>

                    <b-form-checkbox-group
                      id="checkbox-selected-indicators"
                      v-model="selectedIndicators"
                      name="checkbox-selected-indicators"
                    >
                      <b-row>
                        <b-col cols="8">Chiffre d'affaires</b-col>
                        <b-col cols="2">
                          <b-form-radio
                            v-model="indicator"
                            @change="changeIndicator"
                            value="totalAmount"
                          ></b-form-radio>
                        </b-col>
                        <b-col cols="2">
                          <b-form-checkbox
                            value="totalAmount"
                          ></b-form-checkbox>
                        </b-col>
                      </b-row>

                      <b-row>
                        <b-col cols="8">Nombre de chargés de comptes</b-col>
                        <b-col cols="2">
                          <b-form-radio
                            v-model="indicator"
                            @change="changeIndicator"
                            value="nombreChargeAffaires"
                          ></b-form-radio>
                        </b-col>
                        <b-col cols="2">
                          <b-form-checkbox
                            value="nombreChargeAffaires"
                          ></b-form-checkbox>
                        </b-col>
                      </b-row>

                      <b-row>
                        <b-col cols="8">Nombre de sites</b-col>
                        <b-col cols="2">
                          <b-form-radio
                            v-model="indicator"
                            @change="changeIndicator"
                            value="nombreSites"
                          ></b-form-radio>
                        </b-col>
                        <b-col cols="2">
                          <b-form-checkbox
                            value="nombreSites"
                          ></b-form-checkbox>
                        </b-col>
                      </b-row>

                      <b-row>
                        <b-col cols="8">Nombre d'opportunités gagnées</b-col>
                        <b-col cols="2">
                          <b-form-radio
                            v-model="indicator"
                            @change="changeIndicator"
                            value="nombreOpportunitesGagnees"
                          ></b-form-radio>
                        </b-col>
                        <b-col cols="2">
                          <b-form-checkbox
                            value="nombreOpportunitesGagnees"
                          ></b-form-checkbox>
                        </b-col>
                      </b-row>

                      <b-row>
                        <b-col cols="8"
                          >Chiffre d'affaires / nombre de sites</b-col
                        >
                        <b-col cols="2">
                          <b-form-radio
                            v-model="indicator"
                            @change="changeIndicator"
                            value="moyenneTotalAmountNombreSites"
                          ></b-form-radio>
                        </b-col>
                        <b-col cols="2">
                          <b-form-checkbox
                            value="moyenneTotalAmountNombreSites"
                          ></b-form-checkbox>
                        </b-col>
                      </b-row>

                      <b-row>
                        <b-col cols="8"
                          >Chiffre d'affaires / nombre d'opportunités
                          gagnées</b-col
                        >
                        <b-col cols="2">
                          <b-form-radio
                            v-model="indicator"
                            @change="changeIndicator"
                            value="moyenneTotalAmountNombreOpportunites"
                          ></b-form-radio>
                        </b-col>
                        <b-col cols="2">
                          <b-form-checkbox
                            value="moyenneTotalAmountNombreOpportunites"
                          ></b-form-checkbox>
                        </b-col>
                      </b-row>

                      <!-- TODO-1-8 -->
                      <!-- TODO-2-8 -->
                      <!-- TODO-3-7 -->

                      <b-row>
                        <b-col cols="8">Nombre d'abonnés </b-col>
                        <b-col cols="2">
                          <b-form-radio
                            v-model="indicator"
                            @change="changeIndicator"
                            value="nombreAbonne"
                          ></b-form-radio>
                        </b-col>
                        <b-col cols="2">
                          <b-form-checkbox
                            value="nombreAbonne"
                          ></b-form-checkbox>
                        </b-col>
                      </b-row>
                    </b-form-checkbox-group>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card>
          </b-collapse>
        </b-col>
        <b-col>
          <div style="height: 600px; width: 100%">
            <l-map
              ref="map"
              v-if="map.showMap"
              :zoom="map.zoom"
              :center="map.center"
              :options="map.mapOptions"
              style="height: 100%"
              @update:center="centerUpdate"
              @update:zoom="zoomUpdate"
            >
              <l-tile-layer :url="map.url" :attribution="map.attribution" />

              <div :v-if="markersShowed.length >= 1">
                <div v-if="clustering === 'auto'">
                  <v-marker-cluster :options="clusterOptions">
                    <l-marker
                      v-for="m in markersShowed"
                      :key="m.id"
                      :lat-lng="m.coordinates"
                    >
                      <MarkerComponent :m="m"></MarkerComponent>
                    </l-marker>
                  </v-marker-cluster>
                </div>
                <div v-else>
                  <l-marker
                    v-for="m in markersShowed"
                    :key="m.id"
                    :lat-lng="m.coordinates"
                  >
                    <MarkerComponent :m="m"></MarkerComponent>
                  </l-marker>
                </div>
              </div>

              <l-choropleth-layer
                v-if="coloring !== 'none'"
                :data="chloroMapData"
                :titleKey="chloroMapTitleKey"
                :idKey="chloroMapIdKey"
                :value="chloroMapValue"
                :extraValues="chloroExtraValues"
                :geojsonIdKey="chloroMapGeoJsonIdKey"
                :geojson="chloroMapGeoJson"
                :colorScale="chloroMap.colorScale"
              >
                <template slot-scope="props">
                  <l-info-control
                    :item="props.currentItem"
                    :unit="props.unit"
                    :title="chloroMapInfoTitle"
                    :placeholder="chloroMapInfoPlaceholder"
                  />
                  <l-reference-chart
                    :title="chloroMapReferenceChartTitle"
                    :colorScale="chloroMap.colorScale"
                    :min="props.min"
                    :max="props.max"
                    position="topright"
                  />
                </template>
              </l-choropleth-layer>

              <l-geo-json
                :visible="drawMarkers"
                :geojson="drawGeoJsonOptions('markers')"
              />
              <l-geo-json
                :visible="drawUsers"
                :geojson="drawGeoJsonOptions('users')"
              />
              <l-geo-json
                :visible="drawDepartements"
                :geojson="drawGeoJsonOptions('departements')"
              />
              <l-geo-json
                :visible="drawRegions"
                :geojson="drawGeoJsonOptions('regions')"
              />
              <l-geo-json
                :visible="drawRegionsSF"
                :geojson="drawGeoJsonOptions('regionsSF')"
              />
            </l-map>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
  <div v-else>
    <Loading class="mt-4 text-center" :loading-circle="true" />
  </div>
</template>

<script>
import { latLng } from "leaflet";
import { LMap, LTileLayer, LMarker, LGeoJson } from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import { Icon } from "leaflet";
import Vue2LeafletMarkercluster from "vue2-leaflet-markercluster";
import "leaflet/dist/images/marker-icon.png";
import "leaflet/dist/images/marker-shadow.png";
import "leaflet.markercluster.freezable";
import MarkerComponent from "./MarkerComponent";
import { InfoControl, ReferenceChart, ChoroplethLayer } from "vue-choropleth";
import Loading from "./Loading";
import { mapGetters } from "vuex";
let _ = require("lodash");

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

export default {
  name: "Map",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LGeoJson,
    MarkerComponent,
    Loading,
    "v-marker-cluster": Vue2LeafletMarkercluster,
    "l-info-control": InfoControl,
    "l-reference-chart": ReferenceChart,
    "l-choropleth-layer": ChoroplethLayer,
  },
  data() {
    return {
      map: {
        showMap: true,
        zoom: 5,
        currentZoom: 5,
        center: latLng(46.980252, 2.240039),
        currentCenter: latLng(46.980252, 2.240039),
        url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        attribution:
          '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        mapOptions: {
          zoomSnap: 0.5,
        },
      },
      chloroMap: {
        colorScale: [
          "DDDDDD",
          "E8DCAD",
          "EAD684",
          "F2D24D",
          "F2B94D",
          "F2A44D",
          "F28E4D",
          "F2844D",
          "F2704D",
          "F24D4D",
        ],
      },
      c2iCoordinates: latLng(48.703707, 6.129104),
      showMarkers: true,
      drawPolygon: [],
      clustering: "auto",
      coloring: "none",
      indicator: "totalAmount",
      selectedIndicators: [
        "nombreSites",
        "nombreChargeAffaires",
        "nombreChargeAffairesObjectif",
        "totalAmount",
        "nombreOpportunitesGagnees",
        "moyenneTotalAmountNombreSites",
        "moyenneTotalAmountNombreOpportunites",
        "nombreAbonne",
        // TODO-1-8
        // TODO-2-8
        // TODO-3-7
      ],
      loading: false,
      chloroMapValue: {
        key: "totalAmount",
        metric: "€ (chiffre d'affaires)",
      },
    };
  },
  created() {
    document.addEventListener("beforeunload", this.handleClosingPage);
  },
  mounted() {
    this.loading = true;
    this.$store.commit("setAllGeoJsoFromLocalStorage");
    this.loading = false;
  },
  methods: {
    handleClosingPage() {
      this.$store.commit("unstoreAllGeoJson");
    },
    zoomUpdate(zoom) {
      this.map.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.map.currentCenter = center;
    },
    goToCoordinates(coordinates, zoom) {
      this.$refs.map.mapObject.setView(coordinates, zoom);
    },
    drawGeoJsonOptions(drawType) {
      switch (drawType) {
        case "markers":
          return this.geoJsonMarkers;
        case "users":
          return this.geoJsonUsers;
        case "departements":
          return this.geoJsonDepartements;
        case "regions":
          return this.geoJsonRegions;
        case "regionsSF":
          return this.geoJsonRegionsSF;
        default:
          return null;
      }
    },
    geoJsonMarkersChecked(geoJsonOrigin) {
      if (geoJsonOrigin !== null && geoJsonOrigin !== undefined) {
        if (Object.prototype.hasOwnProperty.call(geoJsonOrigin, "features")) {
          if (geoJsonOrigin.features.length >= 1) {
            if (
              geoJsonOrigin.features[0] !== null &&
              geoJsonOrigin.features[0] !== undefined
            ) {
              if (
                Object.prototype.hasOwnProperty.call(
                  geoJsonOrigin.features[0],
                  "properties"
                )
              ) {
                if (
                  geoJsonOrigin.features[0].properties !== null &&
                  geoJsonOrigin.features[0].properties !== undefined
                ) {
                  if (
                    Object.prototype.hasOwnProperty.call(
                      geoJsonOrigin.features[0].properties,
                      "totalAmount"
                    )
                  ) {
                    return true;
                  }
                }
              }
            }
          }
        }
      }
      return false;
    },
    getIndicatorText(indicator) {
      switch (indicator) {
        case "totalAmount":
          return "Chiffre d'affaires";
        case "nombreSites":
          return "Nombre de sites";
        case "nombreChargeAffaires":
          return "Nombre de chargés de comptes";
        case "nombreOpportunitesGagnees":
          return "Nombre d'opportunités";
        case "moyenneTotalAmountNombreSites":
          return "Chiffre d'affaires / nombre de sites";
        case "moyenneTotalAmountNombreOpportunites":
          return "Chiffre d'affaires / nombre d'opportunités";
        case "nombreAbonne":
          return "Nombre d'abonnés";

        // TODO-2-8
        // TODO-3-7
        default:
          return "Indicateur";
      }
    },

    changeIndicator(indicator) {
      let coloring = this.coloring;
      this.coloring = "none";
      let value = {};
      switch (indicator) {
        case "totalAmount":
          value = {
            key: "totalAmount",
            metric: "€ (chiffre d'affaires)",
          };
          break;
        case "nombreOpportunitesGagnees":
          value = {
            key: "nombreOpportunitesGagnees",
            metric: "opportunités",
          };
          break;
        case "nombreChargeAffaires":
          value = {
            key: "nombreChargeAffaires",
            metric: "chargés de comptes",
          };
          break;
        case "nombreSites":
          value = {
            key: "nombreSites",
            metric: "sites",
          };
          break;
        case "moyenneTotalAmountNombreSites":
          value = {
            key: "moyenneTotalAmountNombreSites",
            metric: "€ (chiffre d'affaires / nombre de sites)",
          };
          break;
        case "moyenneTotalAmountNombreOpportunites":
          value = {
            key: "moyenneTotalAmountNombreOpportunites",
            metric: "€ (chiffre d'affaires / nombre d'opportunités)",
          };
          break;
        case "nombreAbonne":
          value = {
            key: "nombreAbonne",
            metric: "abonnés",
          };
          break;
        // TODO-1-8
        // TODO-2-8
        // TODO-3-7
        default:
          value = {
            key: "totalAmount",
            metric: "€ (chiffre d'affaires)",
          };
          break;
      }

      this.coloring = coloring;
      this.chloroMapValue = value;
    },

    constructIndicator(indicator, metric) {
      return {
        key: indicator,
        metric: metric,
      };
    },
  },
  computed: {
    ...mapGetters([
      "markers",
      "geoJsonMarkers",
      "geoJsonUsers",
      "geoJsonTypes",
      "geoJsonTypologies",
      "geoJsonDepartements",
      "geoJsonRegions",
      "geoJsonRegionsSF",
    ]),
    markersShowed() {
      if (this.showMarkers) {
        return this.markers;
      } else {
        return [];
      }
    },
    clusterOptions() {
      if (this.clustering === "none") {
        return {
          disableClusteringAtZoom: 0,
        };
      } else {
        return {};
      }
    },
    chloroExtraValues() {
      let extraValues = [];

      if (this.selectedIndicators.includes("nombreSites")) {
        extraValues.push(this.constructIndicator("nombreSites", "sites"));
      }

      if (this.selectedIndicators.includes("nombreChargeAffaires")) {
        extraValues.push(
          this.constructIndicator("nombreChargeAffaires", "chargés de comptes")
        );
      }

      switch (this.coloring) {
        case "regionSF":
          if (
            this.selectedIndicators.includes("nombreChargeAffairesObjectif")
          ) {
            extraValues.push(
              this.constructIndicator(
                "nombreChargeAffairesObjectif",
                "chargés de comptes (objectif)"
              )
            );
          }
          break;
        default:
          break;
      }

      if (this.selectedIndicators.includes("nombreOpportunitesGagnees")) {
        extraValues.push(
          this.constructIndicator("nombreOpportunitesGagnees", "opportunités")
        );
      }
      if (this.selectedIndicators.includes("moyenneTotalAmountNombreSites")) {
        extraValues.push(
          this.constructIndicator(
            "moyenneTotalAmountNombreSites",
            "€ (chiffre d'affaires / nombre de sites)"
          )
        );
      }
      if (
        this.selectedIndicators.includes("moyenneTotalAmountNombreOpportunites")
      ) {
        extraValues.push(
          this.constructIndicator(
            "moyenneTotalAmountNombreOpportunites",
            "€ (chiffre d'affaires / nombre d'opportunités)"
          )
        );
      }

      // TODO-1-8
      // TODO-2-8
      // TODO-3-7

      if (this.selectedIndicators.includes("nombreAbonne")) {
        extraValues.push(this.constructIndicator("nombreAbonne", "abonnés"));
      }

      return extraValues;
    },
    chloroMapReferenceChartTitle() {
      return this.getIndicatorText(this.indicator);
    },

    chloroMapData() {
      switch (this.coloring) {
        case "departement":
          return _.map(this.geoJsonDepartements.features, "properties");
        case "region":
          return _.map(this.geoJsonRegions.features, "properties");
        case "regionSF":
          return _.map(this.geoJsonRegionsSF.features, "properties");
        case "chargeAffaires":
          return _.map(this.geoJsonUsers.features, "properties");
        case "type":
          return _.map(this.geoJsonTypes.features, "properties");
        case "typology":
          return _.map(this.geoJsonTypologies.features, "properties");
      }
      return null;
    },
    chloroMapTitleKey() {
      switch (this.coloring) {
        case "departement":
          return "nom";
        case "region":
          return "nom";
        case "regionSF":
          return "nom";
        case "chargeAffaires":
          return "name";
        case "type":
          return "name";
        case "typology":
          return "name";
      }
      return null;
    },
    chloroMapIdKey() {
      switch (this.coloring) {
        case "departement":
          return "code";
        case "region":
          return "code";
        case "regionSF":
          return "nom";
        case "chargeAffaires":
          return "name";
        case "type":
          return "name";
        case "typology":
          return "name";
      }
      return null;
    },
    chloroMapGeoJsonIdKey() {
      switch (this.coloring) {
        case "departement":
          return "code";
        case "region":
          return "code";
        case "regionSF":
          return "nom";
        case "chargeAffaires":
          return "name";
        case "type":
          return "name";
        case "typology":
          return "name";
      }
      return null;
    },
    chloroMapGeoJson() {
      switch (this.coloring) {
        case "departement":
          return this.geoJsonDepartements;
        case "region":
          return this.geoJsonRegions;
        case "regionSF":
          return this.geoJsonRegionsSF;
        case "chargeAffaires":
          return this.geoJsonUsers;
        case "type":
          return this.geoJsonTypes;
        case "typology":
          return this.geoJsonTypologies;
      }
      return null;
    },
    chloroMapInfoTitle() {
      switch (this.coloring) {
        case "departement":
          return "Département";
        case "region":
          return "Région";
        case "regionSF":
          return "Région C2i santé";
        case "chargeAffaires":
          return "Chargé d'affaires";
        case "type":
          return "Type";
        case "typology":
          return "Typologie";
      }
      return null;
    },
    chloroMapInfoPlaceholder() {
      switch (this.coloring) {
        case "departement":
          return "Sélectionnez un département";
        case "region":
          return "Sélectionnez une région";
        case "regionSF":
          return "Sélectionnez une région C2i santé";
        case "chargeAffaires":
          return "Sélectionnez un chargé d'affaires";
        case "type":
          return "Sélectionnez un type";
        case "typology":
          return "Sélectionnez une typologie";
      }
      return null;
    },
    drawMarkers() {
      return this.drawPolygon.includes("markers");
    },
    drawUsers() {
      return this.drawPolygon.includes("users");
    },
    drawDepartements() {
      return this.drawPolygon.includes("departements");
    },
    drawRegions() {
      return this.drawPolygon.includes("regions");
    },
    drawRegionsSF() {
      return this.drawPolygon.includes("regionsSF");
    },
  },
};
</script>

<style scoped>
@import "~leaflet/dist/leaflet.css";
@import "~leaflet.markercluster/dist/MarkerCluster.css";
@import "~leaflet.markercluster/dist/MarkerCluster.Default.css";

.c2icolor {
  background-color: #009de0;
}
</style>
